import * as React from "react"
import { create } from "zustand"

import {
  examRoleFromLoginSession,
  type ExamAppRole,
} from "@/lib/exam-blueprint-access"
import { useExamRoleStore, syncExamRoleFromLoginSession } from "@/contexts/exam-role-context-shared"

export function ExamRoleProvider({ children }: { children: React.ReactNode }) {
  React.useEffect(() => {
    syncExamRoleFromLoginSession()
  }, [])
  return <>{children}</>
}

export function useExamRole() {
  const role = useExamRoleStore((state) => state.role)
  const setRole = useExamRoleStore((state) => state.setRole)
  return { role, setRole }
}

export function useCanManageAssessmentBlueprint(): boolean {
  const role = useExamRoleStore((state) => state.role)
  return role === "Admin"
}
